import React, { useCallback, useMemo } from 'react';
import { components } from 'react-select';

import Select from '@xcritical/select';

import { ISelectOption } from '@crm-framework/form-fields';

import { useDictionary, tagColors } from '@crm-package/dictionaries';

import { ILeadFormFieldProps } from '../types';
import { LabelColor, LabelOption } from '../styled';
import { LeadDetailsDictionaries } from '../consts';

interface ILabelProps {
  label: string;
  color: string;
  size: number;
}

export const Label: React.FC<ILabelProps> = ({ label, color, size }) => (
  <LabelOption>
    <LabelColor tagColor={color} size={size} />
    {label}
  </LabelOption>
);

export const SelectLabel: React.FC<ILeadFormFieldProps<ISelectOption[]>> = ({
  onChange,
  defaultValue,
  value,
  options,
  ...rest
}) => {
  const leadTags = useDictionary(LeadDetailsDictionaries.leadTag);
  const onHandleChange = useCallback(
    (v: ISelectOption[]) => {
      onChange(v);
    },
    [onChange]
  );
  const colorsArray = useMemo(
    () =>
      options ??
      leadTags.map((item) => ({
        label: item.name,
        value: item.id,
        color: tagColors[item.colorAlias],
      })),
    [leadTags]
  );
  const { Option } = components;

  const IconOption = (props) => {
    const { data } = props;

    return (
      <Option {...props}>
        <Label label={data.label} color={data.color} size={16} />
      </Option>
    );
  };
  const formatOptionLabel = ({ label, value: currentValue }) => {
    const color = colorsArray.find((item) => item.value === currentValue)
      ?.color!;

    return <Label label={label} color={color} size={12} />;
  };

  return (
    <Select
      options={colorsArray}
      appearance="compact"
      onChange={onHandleChange}
      isMulti
      isSearchable
      components={{
        Option: IconOption,
      }}
      value={value}
      defaultValue={defaultValue}
      formatOptionLabel={formatOptionLabel}
      menuPosition="fixed"
      isCloseMenuOnSelect={false}
      {...rest}
    />
  );
};
